<mat-dialog-content id="dialog-content">
  <table mat-table [dataSource]="matTableDataSource">

    <ng-container [matColumnDef]="CST_MAT_TABLE_COL_NAME">
      <th mat-header-cell *matHeaderCellDef>{{'Nom' | translate}}</th>
      <td mat-cell *matCellDef="let contact">
        <div style="padding: 0 10px">
          {{asContact(contact).Name}}
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_TABLE_COL_LAST_NAME">
      <th mat-header-cell *matHeaderCellDef>{{'Prenom' | translate}}</th>
      <td mat-cell *matCellDef="let contact">
        <div style="padding: 0 10px">
          {{asContact(contact).LastName}}
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_TABLE_COL_PHONE">
      <th mat-header-cell *matHeaderCellDef>{{'Téléphone' | translate}}</th>
      <td mat-cell *matCellDef="let contact">
        <div style="padding: 0 10px">
          {{asContact(contact).Phone}}
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_TABLE_COL_EMAIL">
      <th mat-header-cell *matHeaderCellDef>{{'Email' | translate}}</th>
      <td mat-cell *matCellDef="let contact">
        <div style="padding: 0 10px">
          {{asContact(contact).Email}}
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="CST_MAT_TABLE_COL_ACTION">
      <th mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
      <td mat-cell *matCellDef="let contact">
        <div class="button-group">
          <button mat-raised-button color="primary" (click)="onBtnItemClick(contact, false)">{{'Sélectionner' | translate}}</button>
          <button mat-raised-button (click)="onBtnItemClick(contact, true)">{{'Modifier' | translate}}</button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="matTableDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let contact; columns: matTableDisplayedColumns"></tr>

  </table>

  <mat-progress-bar *ngIf="loadingData" mode=indeterminate></mat-progress-bar>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-raised-button tabindex="4" (click)="onBtnDialogClick('addNew')">{{'Ajouter' | translate}}</button>
  <button mat-raised-button tabindex="4" (click)="onBtnDialogClick('close')">{{'Fermer' | translate}}</button>
</div>
